// extracted by mini-css-extract-plugin
export default {"cls1":"SplitMobileFab-MenuOptionFab_cls1__1FaO0","cls2":"SplitMobileFab-MenuOptionFab_cls2__aBQSr SplitMobileFab-MenuOptionFab_cls1__1FaO0"};